import Modal from "@/components/Common/Modal";
import useBuyoutBundlePurchase from "@/hooks/useBuyoutBundlePurchase";
import AddMoreBuyoutsContent from "@/pages/plans/AddMoreBuyoutsContent";
import {isMoreBuyoutsModalOpenAtom} from "@/store/jotaiAtoms";
import {useAtom} from "jotai";
import {RESET} from "jotai/utils";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const AddMoreBuyoutsModal: FC = () => {
  const {t} = useTranslation("payments");
  const [modalAtom, setModalAtom] = useAtom(isMoreBuyoutsModalOpenAtom);
  const purchase = useBuyoutBundlePurchase({type: modalAtom.type});

  return (
    <Modal
      backgroundClassName="max-w-180"
      isConfirmDisabled={purchase.selectedOption === null}
      modalTitle={t(`${modalAtom.type as "EXTRA_BUYOUTS"}_add_more`)}
      onClose={() => setModalAtom(RESET)}
      onConfirm={purchase.purchase}>
      <AddMoreBuyoutsContent purchase={purchase} type={modalAtom.type} />
    </Modal>
  );
};

export default AddMoreBuyoutsModal;
